import { render, staticRenderFns } from "./HealthDisclaimer.vue?vue&type=template&id=b8668962"
var script = {}
import style0 from "./HealthDisclaimer.vue?vue&type=style&index=0&id=b8668962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports